import React, { FC } from "react";

import { useArray } from "~/hooks";

import { useApisInsightPostsLikedEmployeesIndex } from "../hooks/members";

import { ReactedEmployeeType } from "~/domains";

import { ReactedEmployeesModal } from "~/ui";

type PropsType = {
  insightPostId: string;
  onClose: () => void;
};

export const InsightPostsLikedEmployeesModal: FC<PropsType> = ({
  insightPostId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisInsightPostsLikedEmployeesIndex({
      insightPostId,
      config: {
        onSuccess: (data) => {
          setItems(data.pages.map((page) => page.insightPostLikes).flat());
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
